import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import VoucherHeader from "../../components/Voucher/VoucherHeader";
import VoucherList from "../../components/Voucher/VoucherList";

const VoucherPage = () => {
  return (
    <div className="px-3 py-2">
      <Breadcrumb currentPage="Voucher List" />
      <VoucherHeader />
      <VoucherList />
    </div>
  );
};

export default VoucherPage;
